import { Box, makeStyles, Switch } from '@material-ui/core';
import React from 'react';
import { updateOfferPlan } from '../../../../services/masterDataService';
import ScreenWrapper from '../../../commons/ScreenWrapper';
import Text from '../../../commons/Text';
import PlanForm from '../../../layouts/Admin/Plans/PlanForm';


const useStyles = makeStyles(theme => ({
    switch: {
        '& .MuiSwitch-track': {
            backgroundColor: theme.palette.ascents.white
        }
    }
}))

const AdminPlanFormScreen = ({
    title,
    match,
    readOnly = false
}) => {
    const classes = useStyles()
    const { id } = match && match.params ? match.params : {};
    const [offerIsActive, setOfferIsActive] = React.useState(false);

    const handleChange = (event) => {
        const { checked } = event.target
        setOfferIsActive(checked)

        updateOfferPlan({
            is_active: checked ? 1 : 0
        }, id).then((response) => {
            console.log(response);
        })
    };

    return (
        <ScreenWrapper
            pageTitle={title}
            hasForm
            ActionComponent={
                () => id ? (
                    <Box display='flex' alignItems='center' justifyContent='flex-end'>
                        <Text fontWeight={600} style={{ marginRight: 16 }}>Visibility:</Text>
                        <Text opacity={!offerIsActive ? 1 : 0.5}>Draft</Text>
                        <Switch
                            className={classes.switch}
                            checked={offerIsActive}
                            onChange={handleChange}
                            name="offerIsActive"
                            inputProps={{ 'aria-label': 'toggle offer active status' }}
                        />
                        <Text opacity={offerIsActive ? 1 : 0.5}>Public</Text>
                    </Box>
                ) : null
            }
        >
            <PlanForm match={match} readOnly={readOnly} setOfferIsActive={setOfferIsActive} />
        </ScreenWrapper>
    )
}

export default AdminPlanFormScreen
